import { useEffect, useRef } from "react";

declare global {
  interface Window {
    google: any;
  }
}

export function useGoogleCodeFlow(onCode: (code: string) => void) {
  const codeClientRef = useRef<any>(null);

  useEffect(() => {
    if (!window.google?.accounts?.oauth2) return;

    codeClientRef.current = window.google.accounts.oauth2.initCodeClient({
      client_id:
        "45895851172-ktp5kooeukn76psdc6flesjl48be14oq.apps.googleusercontent.com",
      scope: "https://www.googleapis.com/auth/gmail.send",
      ux_mode: "popup",
      prompt: "consent", // la 1ª vez para asegurar refresh_token
      callback: (resp: any) => {
        if (resp?.code) onCode(resp.code);
      },
    });
  }, [onCode]);

  const trigger = () => codeClientRef.current?.requestCode();
  return { trigger };
}
